import { ApiClient } from '@travel/api-client';

export const ApiFetchQrCode = (http: ApiClient, query: Object): Promise<any> => {
  return http.get('/qrcodegenerator/generateQrCode', { values: query });
};
